import React from 'react';
const IdSetter = (props) => {
    const value = props?.value;
    return React.createElement("div", { style: { '-webkit-user-select': 'text' } }, value);
};
export default IdSetter;
